import { createLocalize } from "@uxf/localize";
import cs from "@uxf/localize/locale/cs";

export const {
    FormatDateTime,
    FormatMoney,
    FormatNumber,
    FormatPercentage,
    LocalizeProvider,
    formatDateTime,
    formatMoney,
    formatNumber,
    formatPercentage,
    useFormatDateTime,
    useFormatMoney,
    useFormatNumber,
    useFormatPercentage,
    useLocaleConfig,
} = createLocalize({ cs });
